import { Person as GraphQlPerson } from "@radivision/graphql/lib/ts/graphql/person";
import React from "react";
import { DetailsTab } from "../profile-details-tab/details-tab";
import { ENVIRONMENT } from "../../../relay/relay-environment";

export interface PersonDetailsProps {
  person: GraphQlPerson;
  updateContext: (person: GraphQlPerson) => void;
  user: GraphQlPerson;
}

export class PersonDetails extends React.Component<PersonDetailsProps,{}> {
  render(): React.ReactNode {
    const { user, person, updateContext } = this.props;
    return (
      <div className="profile-details">
        <DetailsTab
          person={person}
          isCompany={false}
          isPerson={true}
          isSpectator={false}
          isOwner={user && person && user?.id === person?.id}
          updateUser={updateContext}
          environment={ENVIRONMENT}
        />
      </div>
    );
  }
}
